<div class="spinner-overlay" *ngIf="showSpinner">
  <div class="spinner-container">
    <div class="loadingio-spinner-cube-loopybqvm68">
      <div class="ldio-s7fpc21dt6">
        <div></div><div></div><div></div><div></div>
      </div>
    </div>
  </div>
</div>
